import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Module 6 — source_activity catalogue.
 *
 * Mirrors the action_log.source_activity CHECK constraint:
 *   strategic_focus | new_creator_at_risk | tier_gap |
 *   one_on_one_call | creator_alert | bonus_gap
 *
 * Each entry provides label, icon, and accent color used by chips & rows.
 */
export const SOURCES = [
  { id: 'strategic_focus',     label: 'Strategic focus',  icon: 'spark',     color: TCN.diamond },
  { id: 'new_creator_at_risk', label: 'New creator',      icon: 'people',    color: TCN.amber },
  { id: 'tier_gap',            label: 'Tier gap',         icon: 'tiers',     color: TCN.cyan },
  { id: 'one_on_one_call',     label: '1-on-1 call',      icon: 'phone',     color: TCN.green },
  { id: 'creator_alert',       label: 'Creator alert',    icon: 'warn',      color: TCN.red },
  { id: 'bonus_gap',           label: 'Bonus gap',        icon: 'cash',      color: TCN.magenta },
];

export const SOURCE_BY_ID = Object.fromEntries(SOURCES.map(s => [s.id, s]));

export const STATUSES = [
  { id: 'open',         label: 'Open',         color: TCN.amber },
  { id: 'in_progress',  label: 'In progress',  color: TCN.cyan },
  { id: 'done',         label: 'Done',         color: TCN.green },
  { id: 'cancelled',    label: 'Cancelled',    color: TCN.textMute },
];

export const STATUS_BY_ID = Object.fromEntries(STATUSES.map(s => [s.id, s]));
